import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestTeethAlignersWrapper from "@components/layouts/bestteethalignersWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <BestTeethAlignersWrapper>
            <TermsAndConditions
                category="Teeth Aligners"
                domain="bestteethaligners.com"
            />
        </BestTeethAlignersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
